import styled from 'styled-components'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 8px;
  padding: 12px;
`

export default Card